/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedRequestString } from '../../models/paged-request-string';

export interface ExportBroadcastDetailsSearchExcel$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  lang: string;
  exportContactAttribute?: boolean;
      body: PagedRequestString
}

export function exportBroadcastDetailsSearchExcel(http: HttpClient, rootUrl: string, params: ExportBroadcastDetailsSearchExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportBroadcastDetailsSearchExcel.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('lang', params.lang, {});
    rb.query('exportContactAttribute', params.exportContactAttribute, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportBroadcastDetailsSearchExcel.PATH = '/v1/api/ui/broadcast/details/export-excel-search/{lang}';
